(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-hero-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const bannerSwiper = new Swiper('.banner-swiper', {
      navigation: {
        nextEl: '.banner-next-slide',
        prevEl: '.banner-prev-slide'
      },
     /*  pagination: {
        el: '.banner-swiper-pagination',
        clickable: true
      }, */
      loop: true,
      autoplay: {
        delay: 7500,
        disableOnInteraction: false
      }
    });
    window.addEventListener('resize', () => {
      bannerSwiper.update();
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    const tableClicks = document.querySelectorAll('.comparison-table');
    const tableBlocks = document.querySelectorAll('.comparison-table-block');

    tableClicks.forEach((tableClick, index) => {
      tableClick.addEventListener('click', function() {
        const tableBlock = tableBlocks[index];
        if (tableBlock.style.opacity !== "0") {
          tableBlock.style.opacity = "0";
          tableBlock.style.height = "0";
        } else {
          tableBlock.style.opacity = "1";
          tableBlock.style.height = "auto";
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haj-product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {

    const nextSlide = document.querySelector('.next-slide')
    const prevSlide = document.querySelector('.prev-slide')

    const disabledImg = nextSlide.querySelector('.disabled')
    const abledImg = nextSlide.querySelector('.abled')

    const disabledPrevImg = prevSlide.querySelector('.disabled')
    const abledPrevImg = prevSlide.querySelector('.abled')


    const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      loop: false,
      init: false,
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 20,

      breakpoints: {
        768: {
          slidesPerView: 2.1,
          spaceBetween: 20,
          centeredSlides: true
        }
      },

      pagination: {
        el: '.swiper-pagination'
      },

      navigation: {
        nextEl: '.next-slide',
        prevEl: '.prev-slide'
      },

      scrollbar: {
        el: '.swiper-scrollbar'
      }
    });

    swiper.on('init', () => {
      disabledPrevImg.style.display = 'block'
      abledPrevImg.style.display = 'none'
    })

    swiper.on('slideChange', () => {
      hideSlideImgs()
    })

    const hideSlideImgs = () => {
      if (nextSlide.disabled) {
        disabledImg.style.display = 'block'
        abledImg.style.display = 'none'
      } else {
        disabledImg.style.display = 'none'
        abledImg.style.display = 'block'
      }

      if (prevSlide.disabled) {
        disabledPrevImg.style.display = 'block'
        abledPrevImg.style.display = 'none'
      } else {
        disabledPrevImg.style.display = 'none'
        abledPrevImg.style.display = 'block'
      }
    };

    swiper.init();

    window.addEventListener('resize', () => {
      swiper.update();
    });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haj-start-block"] && !Shopify.designMode) return;
  try {
     

document.addEventListener('DOMContentLoaded', () => {
    const videoSection = document.querySelector('.play-video')
    const videoButton = document.querySelectorAll('.video-button')
    const hajContent = document.querySelector('.haj-video-block-content')
    const iframe = document.querySelector('.youtube')

    const url = iframe.src

    let value

    const extractValue = () => {
      const start = url.indexOf("embed/") + "embed/".length
      const end = url.indexOf("?autoplay")

      return url.substring(start, end)
    }

    const showVideo = () => {
      value = extractValue(url)

      videoSection.classList.remove('display-none')
      hajContent.classList.add('display-none')

      iframe.setAttribute('src', `https://www.youtube.com/embed/${value}?autoplay=1&mute=0`)
    }

    videoButton.forEach((button) =>  {
      button.addEventListener('click', () => {
        showVideo()
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haj-video-block"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    const videoSection = document.querySelector('.play-video')
    const videoButton = document.querySelectorAll('.video-button')
    const hajContent = document.querySelector('.haj-video-block-content')
    const iframe = document.querySelector('.youtube')

    const url = iframe.src

    let value

    const extractValue = () => {
      const start = url.indexOf("embed/") + "embed/".length
      const end = url.indexOf("?autoplay")

      return url.substring(start, end)
    }

    const showVideo = () => {
      value = extractValue(url)

      videoSection.classList.remove('display-none')
      hajContent.classList.add('display-none')

      iframe.setAttribute('src', `https://www.youtube.com/embed/${value}?autoplay=1&mute=0`)
    }

    videoButton.forEach((button) =>  {
      button.addEventListener('click', () => {
        showVideo()
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
